module.exports = __webpack_public_path__ + "img/l4.3ca4e57f.png";